export default {
    init() {
        const dropdowns = Array.from(document.querySelectorAll('.dropdown.dropdown--terms'));

        /** Click event to open dropdown */
        if (document.querySelector('[data-action=open-dropdown]')) {
            Array.from(document.querySelectorAll('[data-action=open-dropdown]'))
                .forEach(el => {
                    el.addEventListener('click', e => {
                        if (e.target.dataset.action === "open-dropdown") {
                            let dropdown = e.currentTarget.querySelector('.dropdown.dropdown--terms');
                            dropdown.classList.toggle('open');
                        }
                    });
                });
        }

        /** Click event to close download */
        if (dropdowns.length) {
            dropdowns.forEach(el => {

                el.addEventListener('mouseleave', e => {
                    el.classList.toggle('open', false);
                });

                el.querySelector('.dropdown__overlay').addEventListener('click', e => {
                    if (e.target.classList.contains('dropdown__overlay')) {
                        el.classList.toggle('open', false);
                    }
                });
            });
        }
    }
}
